if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.navBound = false;
        this.onKeydown = this.onKeydown.bind(this);
      }

      hide() {
        this.pauseActiveMedia();
        this.removeEventListener('keydown', this.onKeydown);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindNav();
        this.addEventListener('keydown', this.onKeydown);
      }

      /* 模态框内所有顶级媒体节点（img / deferred-media / model 容器），均带 data-media-id */
      mediaItems() {
        const content = this.querySelector('[role="document"]');
        if (!content) return [];
        return Array.from(content.children).filter((el) => el.hasAttribute('data-media-id'));
      }

      currentIndex() {
        return this.mediaItems().findIndex((el) => el.classList.contains('active'));
      }

      bindNav() {
        if (this.navBound) return;
        this.navBound = true;
        const prev = this.querySelector('[data-pmodal-prev]');
        const next = this.querySelector('[data-pmodal-next]');
        if (prev) prev.addEventListener('click', () => this.step(-1));
        if (next) next.addEventListener('click', () => this.step(1));
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') this.step(-1);
        else if (event.key === 'ArrowRight') this.step(1);
      }

      /* 循环切换：图片 / 视频 / 模型通用 */
      step(dir) {
        const items = this.mediaItems();
        if (items.length < 2) return;
        const idx = (this.currentIndex() + dir + items.length) % items.length;
        this.activate(items[idx]);
      }

      /* 切走前停掉正在播放的视频（原生 video 暂停；YouTube iframe 发 pauseVideo 指令） */
      pauseActiveMedia() {
        const active = this.querySelector('[role="document"] > .active');
        if (!active) return;
        active.querySelectorAll('video').forEach((v) => v.pause());
        active.querySelectorAll('iframe').forEach((f) => {
          if ((f.src || '').includes('youtube')) {
            f.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
          }
        });
      }

      activate(el) {
        this.pauseActiveMedia();
        this.mediaItems().forEach((m) => m.classList.toggle('active', m === el));
        // 视频首次切到时按需加载并自动播放（deferred-media 模板内含 autoplay）
        if (el.nodeName === 'DEFERRED-MEDIA' && el.querySelector('template') && !el.getAttribute('loaded')) {
          el.loadContent(false);
        }
        const cur = this.querySelector('[data-pmodal-current]');
        if (cur) cur.textContent = String(this.mediaItems().indexOf(el) + 1);
      }

      showActiveMedia() {
        const items = this.mediaItems();
        if (!items.length) return;
        const id = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        const target = items.find((m) => m.getAttribute('data-media-id') === id) || items[0];
        items.forEach((m) => m.classList.toggle('active', m === target));

        const total = this.querySelector('[data-pmodal-total]');
        if (total) total.textContent = String(items.length);
        const cur = this.querySelector('[data-pmodal-current]');
        if (cur) cur.textContent = String(items.indexOf(target) + 1);
      }
    }
  );
}
